class ShareOrderShareWorkerBuffer {
    list;
    // 5초
    interval = 5000;
    timerId = null;
    constructor() {
        this.list = new Set();
    }
    startTimer() {
        if (this.timerId) {
            this.clearTimer();
        }
        this.timerId = setTimeout(() => {
            // this.print();
            this.truncate();
            this.timerId = null;
        }, this.interval);
    }
    clearTimer() {
        clearTimeout(this.timerId ?? undefined);
        this.timerId = null;
    }
    add(orderId) {
        this.list.add(orderId);
        this.startTimer();
    }
    delete(orderId) {
        this.list.delete(orderId);
    }
    has(orderId) {
        return this.list.has(orderId);
    }
    print() {
        const text = [];
        this.list.forEach((value) => {
            text.push(value);
        });
        console.log(text.join());
    }
    truncate() {
        this.list.clear();
    }
}
export default new ShareOrderShareWorkerBuffer();
